<template>
  <div style="color: black;width: 100%;display: flex;flex-direction: column;justify-items: center;align-items: center">
    <!--    <NavBar v-if="!this.$store.state.isApp" title="医学评估主页"/>-->
    <div class="page-content">
      <div class="tips" v-if="showTip2">{{ tips }}</div>
      <div style="position: relative;width: 100%">
        <img class="img1"
             src="https://cdn.keihong.tech/typora/2022-09-07-Xnip2022-09-07_12-03-33.jpg">
        <img class="img1"
             src="https://docan-static.oss-cn-shenzhen.aliyuncs.com/verticle.jpeg">
        <div
          style="width: 100%;position: absolute;top: 350px;display: flex;flex-direction: column;align-items: center">
          <van-button type="primary" style="width: 300px;height: 100px;font-size: 24px" round @click="download(2)">
            患者端
          </van-button>

          <van-button type="primary" style="width: 300px;height: 100px;margin-top: 32px;font-size: 24px" round
                      @click="download(1)">
            医生端
          </van-button>
        </div>
      </div>
      <div style="width: 100%;margin-top: 16px;text-align: center">
        <div>健而康科技信息服务(中山)有限公司</div>
        <a
          :underline="false"
          style="color:#4f4f4f"
          href="https://beian.miit.gov.cn/"
          target="_blank"
        >粤ICP备17160222号
        </a>
      </div>
      <van-popup position="top" class="pop-tips" v-model="showTip">点击右上角按钮【···】，在弹出的菜单中，点击「在浏览器中打开」，即可安装
      </van-popup>
    </div>
  </div>

</template>

<script>

import { Dialog } from 'vant'

export default {
  name: 'Index',
  data () {
    return {
      isWeixin: false,
      isAndroid: false,
      isMac: false,
      showTip: false,
      showTip2: false,
      where: '',
      tips: '点击右上角按钮【···】，在弹出的菜单中，点击「在浏览器中打开」，即可安装'

    }
  },
  created () {
    const { userAgent } = navigator
    this.isWeixin = !!/MicroMessenger/i.test(userAgent)
    this.isAndroid =
      userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
    this.isMac = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  methods: {
    async download (type) {
      console.log('下载')
      // 检查当前是否在微信，若在微信提示跳转到浏览器
      if (this.isWeixin) {
        // var tip = 1
        // if (tip) {
        if (!this.isAndroid) {
          await Dialog({ message: '暂不支持苹果手机' })
        } else {
          // 如果是微信环境，就弹出遮罩层
          this.showTip = true
          this.showTip2 = true
          console.log('weixin')
          this.where = '微信'
        }
      } else {
        if (!this.isAndroid) {
          await Dialog({ message: '暂不支持苹果手机' })
        } else {
          console.log('浏览器')
          this.where = '浏览器'
          const { data: resp } = await this.$http.get('version/update?userType=' + type)
          console.log(resp.data.url)
          this.tips = '正在下载中，请稍后，下载完毕会自动弹出安装提示...'
          this.showTip2 = true
          window.location.href = resp.data.url
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
html body {
  height: 100%;
  width: 100%;
}

.page-content {
  padding: 0;
  width: 100%;
  max-width: 720px;
}

.van-dialog__message {
  font-size: 22px !important;
  padding: 0 !important;
}

.pop-tips {
  box-sizing: border-box;
  line-height: 28px;
  background-color: darkred;
  color: white;
  height: 20%;
  padding: 16px;
  font-size: 22px;
}

.tips {
  padding: 16px;
  background-color: darkred;
  color: white;
  font-size: 22px;
  line-height: 30px;
}

.img1 {
  display: block;
  width: 100%;
  height: auto;

}

.img-bottom {
  margin-bottom: 100px;
}
</style>
